import { isPlainObject, isArray, camelCase } from "lodash"

// Recursively convert the keys in an object from snake_case to camelCase
// https://stackoverflow.com/a/59770133
export default function keysToCamel(obj) {
  if (isPlainObject(obj)) {
    const n = {}
    Object.keys(obj).forEach((k) => (n[camelCase(k)] = keysToCamel(obj[k])))
    return n
  } else if (isArray(obj)) {
    return obj.map((i) => keysToCamel(i))
  }
  return obj
}
